<template>
    <v-card
        class="main-form"
        variant="outlined"
        rounded="0"
        :width="width"
        style="overflow: visible; z-index: inherit"
        elevation="0"
    >
        <v-card-title v-if="$breakpoint.smAndDown && popup" class="d-flex justify-end">
            <v-icon color="white" @click="$emit('close-popup')">mdi-close</v-icon>
        </v-card-title>
        <v-card-title v-else-if="$breakpoint.smAndDown && !popup" class="text-white">
            <span v-if="activeProducts.length > 1">{{ $t(title) }}</span>
        </v-card-title>
        <v-card-text class="text-white">
            <slot name="form" />
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop, mixins} from 'vue-facing-decorator'
    import {AuthInfoMixin} from '~src/mixins/authInfoMixin.src'

    @Component({})
    export class SearchFormLayout extends mixins(AuthInfoMixin) {
        @Prop({default: false, type: Boolean}) popup
        @Prop() title
        @Prop() width
    }

    export default SearchFormLayout
</script>
